import { ApiGetRequest, ApiPutRequest } from '../../../api';
import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Setting Akun Penting',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Akun Penting',
        href: '/adm/fin/setting/akun-penting',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_account_classification',
    sortDesc: true,
    fields: [
      {
        key: 'acc_label',
        label: 'Biaya',
      },
      {
        key: 'description',
        label: 'Deskripsi',
      },
      {
        key: 'code_acc',
        sortable: true,
      },
      {
        key: 'acc_name',
        label: 'Nama Akun',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    acc_alias: {
      kas_pembelian: {
        label: 'Akun Kas Pembelian',
        description: 'Akun Penerimaan Kas saat Pembelian',
      },
      ongkir_beli: {
        label: 'Ongkos Kirim Pembelian',
        description: 'Biaya pengiriman barang timbul saat membeli barang',
      },
      potongan_pembelian: {
        label: 'Potongan Pembelian',
        description:
          'Akun untuk menampung discount yang diberikan oleh pemasok',
      },
      denda_keterlambatan_beli: {
        label: 'Denda Keterlambatan (Beli)',
        description: 'Akun untuk menampung denda yang anda bayar ke pemasok',
      },
      kas_penjualan: {
        label: 'Akun Kas Penjualan',
        description: 'Akun Penerimaan Kas saat Penjualan',
      },
      ongkir_jual: {
        label: 'Ongkis Kirim Penjualan',
        description:
          'Pendapatan atas biaya pengiriman barang yang anda tarik dari pelanggan saat terjadi penjualan',
      },
      potongan_penjualan: {
        label: 'Potongan Penjualan',
        description:
          'Akun untuk menampung discount yang anda berikan kepada pelanggan',
      },
      denda_keterlambatan_jual: {
        label: 'Denda Keterlambatan (Jual)',
        description:
          'Akun untuk menampung denda yang anda tarik dari pelanggan',
      },
      hutang_usaha: {
        label: 'Hutang Usaha',
        description: 'Akun untuk menampung hutang usaha',
      },
      laba_tahun_berjalan: {
        label: 'Laba Tahun Berjalan',
        description:
          'Akun digunakan pada tiap transaksi yang melibatkan akun-akun pendapatan dan biaya',
      },
      laba_ditahan: {
        label: 'Laba Ditahan',
        description:
          'Akun ini akan digunakan ketika Anda menutup buku akhir tahun',
      },
      historical_balancing: {
        label: 'Historical Balancing',
        description:
          'Akun ini akan digunakan sebagai akun penyeimbang sementara jika terdapat ketidakseimbangan di saldo awal akun',
      },
      komisi_penjualan: {
        label: 'Komisi Penjualan',
        description:
          'Akun ini akan digunakan jika Anda telah menetapkan rumus komisi penjualan di data karyawan atau di Tabel Komisi Penjualan',
      },
      hutang_komisi_penjualan: {
        label: 'Hutang Komisi Penjualan',
        description:
          'Akun hutang yang mencatat hutang komisi penjualan yang timbul setiap terjadi penjualan',
      },
      ikhtiar_laba_rugi: {
        label: 'Ikhtisar Laba Rugi',
        description: 'Akun Ikhtisar Laba Rugi untuk jurnal penutup akhir bulan',
      },
      selisih_lebih_kurs: {
        label: 'Selisih Lebih Kurs',
        description:
          'Akun Selisih Lebih Kurs untuk menghitung selisih kelebihan nilai kurs mata uang asing',
      },
      selisih_kurang_kurs: {
        label: 'Selisih Kurang Kurs',
        description:
          'Akun Selisih Kurang Kurs untuk menghitung selisih kekurangan nilai kurs mata uang asing',
      },
    },
    form: {},
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  settingAkun(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchAkunPenting(context, payload = null) {
    let result = await ApiGetRequest(`fin/setup-account/search`, payload);
    return result.error ? false : result.data.object;
  },

  async getListSetupAccount({ commit, state }) {
    commit('settingAkun', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`fin/setup-account`, params);
    commit('settingAkun', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailSetupAccount({ commit }, payload = null) {
    commit('settingAkun', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/setup-account/${payload.id}`);
    commit('settingAkun', {
      loading: false,
    });

    if (!result.error) {
      commit('settingAkun', {
        form: result.data.object,
      });
    }

    return !result.error ? true : false;
  },

  async updateSettingAccount({ commit, state, dispatch }, payload = null) {
    commit('settingAkun', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `fin/setup-account/${payload.id}`,
      state.data.form
    );

    commit('settingAkun', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },
};
